import React, { InputHTMLAttributes, ReactNode } from 'react';
import styles from './Input.module.scss';
import cn from 'classnames';
import InputWrapper, { InputWrapperProps } from './Wrapper/InputWrapper';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement>, InputWrapperProps {
  className?: string;
  icon?: JSX.Element;
  iconAction?: () => void;
  iconLeft?: ReactNode;
  additionalRowInside?: ReactNode;
  info?: string;
}

function Input(props: InputProps) {
  const {
    className,
    icon,
    iconAction,
    iconLeft,
    touched,
    success,
    successBoundary,
    error,
    errorBoundary = true,
    noMessages,
    info,
    wrapperClassName,
    labelClassName,
    messageClassName,
    additionalRowInside,
    additionalRowOutside,
    counting,
    ...inputProps
  } = props;

  const inputClassName = cn(
    icon && styles.inputIconGap,
    iconLeft && styles.inputIconGapLeft,
    className,
    styles.input,
    !!touched && !!error && errorBoundary && styles.inputErrorBorder,
    success && successBoundary && styles.inputSuccessBorder,
  );

  return (
    <InputWrapper
      wrapperClassName={wrapperClassName}
      labelClassName={labelClassName}
      messageClassName={messageClassName}
      noMessages={noMessages}
      additionalRowInside={additionalRowInside}
      additionalRowOutside={additionalRowOutside}
      counting={counting}
      {...props}
    >
      {!!iconLeft && <div className={styles.iconLeft}>{iconLeft}</div>}
      <input className={inputClassName} {...inputProps} />
      {!!icon && (
        <div className={styles.icon} onClick={iconAction}>
          {icon}
        </div>
      )}
      {!!info && <span className={styles.info}>{info}</span>}
    </InputWrapper>
  );
}

export default Input;
